document.addEventListener("DOMContentLoaded", function () {
  var singleitem = document.querySelectorAll(".singleitem");

  singleitem.forEach(function (item) {
    item.addEventListener("click", function () {
      var codeElement = this.querySelector(".copycode b");
      if (codeElement) {
        var codeToCopy = codeElement.innerText;
        copyToClipboard(codeToCopy);
        showAlert("Code copied to clipboard!");
      }
    });
  });

  function copyToClipboard(text) {
    var tempInput = document.createElement("input");
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  }

  function showAlert(message) {
    alert(message);
  }
});

var swiper = new Swiper(".availOffers", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesOffsetAfter: 30,
  freeMode: true,
  direction: "horizontal",
  mousewheel: true,
  breakpoints: {
    0: {
      slidesPerView: 1.7,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 2.3,
      spaceBetween: 10,
    },
  },
});
